<style scoped>

</style>
<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="value"
        :label="label"
        :placeholder="placeholder"
        :required="required"
        :rules="rules"
        :prepend-icon="prependIcon"
        :clearable="clearable"
        :disabled="disabled"
        readonly
        v-bind="attrs"
        @click:clear="clear"
        v-on="on"
      >
        <template v-slot:label> 
          <span><span
            v-show="required"
            style="color:red"
          >*</span>{{ label }}</span>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      :locale="locale"
      :type="type"
      scrollable
      @change="selectDate"
    >
      <v-spacer />
      <div v-if="showButton">
        <v-btn
          text
          color="primary"
          @click="menu = false"
        >
          取消
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="confirm"
        >
          确定
        </v-btn>
      </div>
    </v-date-picker>
  </v-menu>
</template>
<script>
  export default {
    props: {
      value: {
        type: String
      },
      label: {
        type: String,
        default: '选择日期'
      },
      placeholder: {
        type: String,
        default: '点击选择'
      },
      locale: {
        type: String,
        default: 'zh'
      },
      required: {
        type: Boolean,
      },
      rules: {
        type: Array,
      },
      type: {
        type: String,
        default: () => undefined
      },
      showButton: {
        type: Boolean,
        default: () => false
      },
      prependIcon: {
        type: String,
      },
      allowedDates: {
        type: Function
      },
      clearable: {
        type: Boolean,
        default: () => false
      },
      disabled: {
        type: Boolean,
        default: () => false
      }
    },
    data() {
      return {
        menu: false,
        date: this.value
      }
    },
    watch:{
      date(val) {
        this.$emit('input', val)
      },
      value(val) {
        this.date = val
      }
    },
    methods: {
      clear() {
        this.date = null
        this.confirm();// 清空时也应该触发事件
      },
      selectDate() {
        if (!this.showButton) {
          this.confirm()  
        }
      },
      confirm() {
        this.$refs.menu.save(this.date);
        this.$emit('input', this.date);
        this.$emit('change', this.date);
      }
    }
  }
</script>
